module.exports = __webpack_public_path__ + "static/media/17.c255b4ee.mp3";